module.exports = __webpack_public_path__ + "img/vip_icon.d8100a96.svg";